import React from "react";

const ProgressBarComparison = ({ values = [], unit, minValue, maxValue, labels = [] }) => {
    
    const calculatePercentage = (value) => {
        if (maxValue === 0) return 0;
        return (value / maxValue) * 100;
    };

    const getColorClass = (index) => {
        const colors = ['bg-success', 'bg-info', 'bg-warning', 'bg-primary', 'bg-secondary', 'bg-danger'];
        return colors[index % colors.length];
    };

    const formatValue = (val) => {
        return parseFloat(val || 0).toFixed(2);
    };

    // Ensure we have at least one value to display
    if (!values || values.length === 0) {
        return <div className="text-muted">No data available</div>;
    }

    return (
        <div className="progress-bars-container">
            {values.map((value, index) => (
                <div className="mb-2" key={index}>
                    <div className="d-flex justify-content-between mb-1">
                        <small className="text-muted fs11">
                            {labels[index] || `Period ${index + 1}`}
                        </small>
                        <small className="fw-bold fs11">
                            {formatValue(value)} {unit}
                        </small>
                    </div>
                    <div className="progress" style={{ height: '15px' }}>
                        <div 
                            className={`progress-bar ${getColorClass(index)}`} 
                            role="progressbar" 
                            style={{ width: `${calculatePercentage(value)}%` }}
                            aria-valuenow={value} 
                            aria-valuemin={0} 
                            aria-valuemax={maxValue}
                        >
                            {/* Optional: show percentage inside bar */}
                            {/* {calculatePercentage(value) > 10 && `${Math.round(calculatePercentage(value))}%`} */}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProgressBarComparison;